import { ToolbarButton, ToolbarButtonProps } from './ToolbarButton';
import { IconName } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';
import styled from 'styled-components';

export type SparklesToolbarButtonProps = Omit<ToolbarButtonProps, 'icon'> & {
  isLoading?: boolean;
  shouldPulse?: boolean;
};

const PulseWrapper = styled.div<{ $pulse: boolean }>`
  ${({ $pulse }) =>
    $pulse &&
    `
    button {
      background-color: ${colors.surfaceBrand};
    }
  `}
  ${({ $pulse }) => $pulse && `animation: pulse 1.5s 500ms infinite;`}

  transition: background-color 0.3s ease;

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }
`;

export const SparklesToolbarButton = (props: SparklesToolbarButtonProps) => {
  const { isLoading, isDisabled, shouldPulse } = props;

  return (
    <PulseWrapper $pulse={shouldPulse || false}>
      <ToolbarButton
        {...props}
        icon={{
          name: isLoading ? IconName.SPINNER : IconName.SPARKLES,
          color: isDisabled
            ? colors.iconActionDisabled
            : colors.iconActionBrand,
        }}
      />
    </PulseWrapper>
  );
};
